import React, { useEffect, useState } from "react";
import { PageSettings } from "../../config/page-settings.js";
import { _ROUTES, _LOGIN_ROUTE } from "../../config/page-route.jsx";
import { useSelector } from "react-redux";
import { filter } from "lodash";
import { Route, useHistory, useLocation } from "react-router-dom";
import appsettings from "../../appsettings-fe.json";
import Header from "components/header";
import Sidebar from "components/sidebar/index2";
import Footer from "components/footer/index.js";
import ScrollToTop from "./scrolltotop";
import { WebUrl } from "../../util/Constant";

const Content = () => {
	const history = useHistory();
	const location = useLocation();
	const [routes, setRoutes] = useState([]);
	const [scrollTop, setScrollTop] = useState(0);
	const [showScrolledHeader, setShowScrolledHeader] = useState(false);
	const liveChatLicense = parseInt(
		appsettings.ApplicationConfig.liveChatLicense
	);
	const authState = useSelector((state) => state.authState);
	const { pathname } = location;

	useEffect(() => {
		const scrollEvent = () => {
			window.addEventListener("scroll", (e) => {
				setScrollTop(e.target.documentElement.scrollTop);
			});
		};

		scrollEvent();

		return () => {
			//window.removeEventListener("scroll");
		};
	}, []);

	useEffect(() => {
		// Check if current route requires authentication and user is not logged in
		const currentRoute = _ROUTES.find(route => route.path === pathname);
		if (currentRoute && currentRoute.authRequired && !authState.isLoggedIn) {
			// Store the intended destination URL for redirect after login
			sessionStorage.setItem('redirectAfterLogin', pathname);
			// Redirect to login page
			history.push(WebUrl._URL_MAIN);
			return;
		}

		setRoutes(
			filter(
				_ROUTES,
				(route) =>
					authState.isLoggedIn ||
					!route.authRequired ||
					route.path == history.location.pathname
			)
		);
	}, [authState, location, pathname, history]);

	const PrivateRoute = (index, routeData) => {
		// If route requires authentication and user is not logged in, redirect to login
		if (routeData.authRequired && !authState.isLoggedIn) {
			return (
				<Route
					key={index}
					exact={routeData.exact}
					path={routeData.path}
					component={() => {
						// Store the intended destination URL for redirect after login
						sessionStorage.setItem('redirectAfterLogin', routeData.path);
						history.push(WebUrl._URL_MAIN);
						return null;
					}}
				/>
			);
		}

		return (
			<Route
				key={index}
				exact={routeData.exact}
				path={routeData.path}
				component={routeData.component}
			/>
		);
	};

	const headerClassName = () => {
		if (pathname === "/") {
			return scrollTop > 150 ? "fixedme" : "";
		}
		if (pathname === "/download") {
			return "d-none";
		} else {
			if (scrollTop > 150) {
				setShowScrolledHeader(true);
			} else {
				setShowScrolledHeader(false);
			}

			return scrollTop > 150 ? "without-banner fixedme" : "without-banner";
		}
	};

	return (
		<PageSettings.Consumer>
			{({ pageContentFullWidth, pageContentClass, pageContentInverseMode }) => (
				<div
					className={
						"content " +
						(pageContentFullWidth ? "content-full-width " : "") +
						(pageContentInverseMode ? "content-inverse-mode " : "") +
						pageContentClass
					}
				>
					{authState.isLoggedIn && (
						<>
							<Sidebar />
						</>
					)}

					<div className={authState.isLoggedIn ? "content-page" : ""}>
						<ScrollToTop />
						{routes.map((route, index) => PrivateRoute(index, route))}
						<Footer />
					</div>
				</div>
			)}
		</PageSettings.Consumer>
	);
};

export default Content;
